"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tv4 = require('tv4');
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var Product = require('./product');
var Substance = /*#__PURE__*/function () {
  function Substance(opt) {
    _classCallCheck(this, Substance);
    this._id = null;
    this.name = null;
    this.vendor = null;
    this.url = null;
    this.products = [];
    this.synonyms = [];
    this.comments = null;
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(Substance, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.name = opt.name || null;
      this.vendor = opt.vendor || null;
      this.url = opt.url || null;
      this.products = Array.isArray(opt.products) ? opt.products.map(function (product) {
        return new Product(product);
      }) : [];
      this.synonyms = opt.synonyms || [];
      this.comments = opt.comments || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Substance.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'substance.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: ['object', 'null']
          },
          name: {
            type: ['string', 'null']
          },
          vendor: {
            type: ['string', 'null']
          },
          url: {
            type: ['string', 'null']
          },
          products: {
            type: 'array',
            item: {
              $ref: 'product.schema.json'
            }
          },
          synonyms: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          comments: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return Substance;
}();
tv4.addSchema(Product.schema());
module.exports = Substance;